import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3800To3899Service {

  constructor() { }
}
